import { SERVICES } from '../../data/services';
import ServiceCard from './ServiceCard';
import './ServiceGrid.css';

export default function ServiceGrid() {
  return (
    <ul className="service-grid" aria-label="Our services">
      {SERVICES.map((service) => (
        <ServiceCard key={service.id} service={service} />
      ))}
    </ul>
  );
}
